import SafetyPortal from './iocl_safety_portal';
function App() { return <SafetyPortal />; }
export default App;